import { FORMULA_TYPES } from 'constants/all';

import request from 'utils/request';

export default {
  listManufacturers: async (processClassId) =>
    await request.get(`/process_classes/${processClassId}/manufacturers`),

  listMachines: async (processClassId, manufacturerId) =>
    await request.get(
      `/machines?process_class=${processClassId}&manufacturer=${manufacturerId}`,
    ),

  listOpDefs: async (groupId, query) =>
    await request.get(`/suppliers/${groupId}/operation_definitions`, {
      search: query,
    }),

  getOpDef: async (opDefId) =>
    await request.get(`/suppliers/operation_definitions/${opDefId}`),

  createOpDef: async (groupId, data) =>
    await request.post(`/suppliers/${groupId}/operation_definitions`, data),

  updateOpDef: async (groupId, opDefId, data) =>
    await request.patch(`/suppliers/operation_definitions/${opDefId}`, data),

  deleteOpDef: async (opDefId) =>
    await request.delete(`/suppliers/operation_definitions/${opDefId}`),

  copyOpDef: async (opDefId) =>
    await request.post(`/suppliers/operation_definitions/${opDefId}/copy`),

  updateVariable: async (variableId, data) =>
    await request.patch(`/formulas/variables/${variableId}`, data),

  updateOpDefFormula: async (opDefId, formula, revertedFrom) =>
    await request.post(`/suppliers/operation_definitions/${opDefId}/formula`, {
      formula,
      revertedFrom,
    }),

  compileFormula: async (formula, version, supplierId) =>
    await request.post(`/formula/compile/${version}`, {
      formula,
      type: FORMULA_TYPES.OPERATION,
      supplierId,
    }),
};
